import {registerLocaleData} from '@angular/common'
import {provideHttpClient, withInterceptors, withXhr} from '@angular/common/http'
import localeFr from '@angular/common/locales/fr'
import {ApplicationConfig, inject, provideAppInitializer, provideZonelessChangeDetection} from '@angular/core'
import {MAT_CARD_CONFIG} from '@angular/material/card'
import {provideRouter, withHashLocation, withViewTransitions} from '@angular/router'
import {
  authInterceptor,
  ConfigService,
  IConfig,
  ILoginSettings,
  responseInterceptor,
  SPB_LOGIN_SETTINGS,
  SPS_CONFIG
} from '@sparbanken-syd/sparbanken-syd-bankid'
import {routes} from './app.routes'
import {DOCUMENT_PATH} from './application/types'
import {environment} from '../environments/environment'

registerLocaleData(localeFr)

const configServiceConfig: IConfig = {
  authServiceUrl: environment.authServiceUrl,
  domain: environment.domain,
  adminRoles: ['public'],
  sessionStorageKey: 'user-documents-token'
}

export const bootStrap = () => inject(ConfigService).bootstrap()

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: SPB_LOGIN_SETTINGS, useValue: {
        title: 'Välkommen till vår dokumentportal',
        text: 'Här kan du ladda upp dokument som banken har efterfrågat i samband med ditt lånelöfte.' +
          ' Portalen kan inte användas för andra ärenden. ' +
          'För att ladda upp dokument behöver du först identifiera dig med BankID.',
        buttonText: 'Öppna BankID',
        route: [DOCUMENT_PATH, {outlets: {item: 'add'}}]
      } as ILoginSettings
    },
    {provide: SPS_CONFIG, useValue: configServiceConfig},
    provideAppInitializer(bootStrap),
    provideZonelessChangeDetection(),
    provideRouter(routes,
      withViewTransitions(),
      withHashLocation()),
    // note that we actually need XHR here since we rely on progress events.
    provideHttpClient(withXhr(),
      withInterceptors([
        authInterceptor,
        responseInterceptor
      ])
    ),
    {provide: MAT_CARD_CONFIG, useValue: {appearance: 'outlined'}}
  ]
}